import { render, staticRenderFns } from "./configuration-subportion-state-machines-grid.vue?vue&type=template&id=2b228456&scoped=true&"
import script from "./configuration-subportion-state-machines-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-subportion-state-machines-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-subportion-state-machines-grid.scss?vue&type=style&index=0&id=2b228456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b228456",
  null
  
)

export default component.exports